import React from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import Selections from "../../common/Selections";

/**
 * TABLE SYSTEMCOLORS
 */
function ProfileBooks(props) {
  let IdProfile = props.Profile.IdProfile;

  return (
    <Selections
      className="unlock-overflow"
      title="Player Profile Books"
      // GET
      getUrl={"/Player/GetBooks"}
      // SELECTED
      getSelectedUrl={`/Addons/Book_GetPlayerProfilesList?idProfile=${IdProfile}`}
      getSelectedParams={() => props.Profile}
      getSelectedProcess={(data = []) =>
        data.filter(({ checked }) => checked).map(({ idBook }) => idBook)
      }
      // INSERT
      insertUrl={"/Profile/PlayerProfileBook_Insert"}
      insertParams={(_, { idBook }) => ({
        IdBook: idBook,
        IdProfile,
      })}
      // DELETE
      deleteUrl={"/Profile/PlayerProfileBook_Delete"}
      deleteParams={(_, { idBook }) => ({
        IdBook: idBook,
        IdProfile,
      })}
    >
      <TableHeaderColumn visible="none" isKey={true} hidden dataField="idBook">
        IdBook
      </TableHeaderColumn>
      <TableHeaderColumn dataField="description">Description</TableHeaderColumn>
    </Selections>
  );
}

export default ProfileBooks;
